import { lastValueFrom } from 'rxjs';
import { MiscApiService } from './misc-api.service';
import { ImageApiService } from './image-api.service';
import { SignalrService } from './signalr.service';
import { PermissionService } from './permission.service';
import { YearService } from './year.service';
import { NotificationUnreadCountService } from './notification-unread-count.service';
import { KpiAnnualTransitionPendingCountService } from './kpi-annual-transition-pending-count.service';
import { ThemeService } from './theme.service';
import { SafeModeService } from './safe-mode.service';
import { SidebarNotificationService } from './sidebar-notification.service';
import { AppSettingFetcherService } from './app-setting-fetcher.service';
import { ToastrNotificationHandler } from './toastr.notification-handler.service';
import { MNM_NOTIFICATION_HANDLER } from 'mnm-webapp';
import { inject, provideAppInitializer } from '@angular/core';
import { HelperService } from './helper.service';
import { EventSourceService } from '@masar/core/services/event-source.service';
import { ConvexService } from './convex.service';
import { AiService } from './ai.service';
import { LicenseFeatureService } from './license-feature.service';
import { ConfirmService } from '@masar/features/confirm-dialog';

export const serviceProviders = [
    provideAppInitializer(() =>
        lastValueFrom(inject(AppSettingFetcherService).get, {
            defaultValue: undefined,
        })
    ),
    provideAppInitializer(() =>
        lastValueFrom(inject(LicenseFeatureService).loaded$, {
            defaultValue: undefined,
        })
    ),
    AppSettingFetcherService,
    LicenseFeatureService,
    ImageApiService,
    MiscApiService,
    NotificationUnreadCountService,
    KpiAnnualTransitionPendingCountService,
    PermissionService,
    SafeModeService,
    SidebarNotificationService,
    SignalrService,
    ThemeService,
    {
        provide: MNM_NOTIFICATION_HANDLER,
        useClass: ToastrNotificationHandler,
        multi: false,
    },
    YearService,
    HelperService,
    EventSourceService,
    ConvexService,
    AiService,
    ConfirmService,
];
